<script setup lang="ts">
if (import.meta.client) {
  useHead({
    script: [
      {
        src: "/cookie-consent.js",
        defer: true,
      },
    ],
  });
}
</script>

<template>
  <div id="cookie-consent" class="cookie-consent" style="display: none">
    <div class="cookie-consent-content">
      <div class="cookie-consent-text">
        <h4>We Respect Your Privacy</h4>
        <p>
          This website uses cookies and similar technologies, as described in our
          <NuxtLink to="/privacy-policy">Privacy Policy</NuxtLink>,
          to support essential site functionality and, with your consent, to analyze website usage.
        </p>
        <p>
          You may choose to accept or reject optional cookies at any time. For more information, please review our
          <NuxtLink to="/cookie-policy">Cookie Policy</NuxtLink>.
        </p>
      </div>
      <div class="cookie-consent-buttons">
        <button id="cookie-accept-all" class="btn btn-primary cookie-btn">
          Accept All
        </button>
        <button id="cookie-reject" class="btn cookie-btn-secondary cookie-btn">
          Reject Optional
        </button>
      </div>
    </div>
  </div>
</template>

